import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { createContext } from 'react'

export const SavedJobsContext = createContext<{
  savedJobs: { jobReferenceClean: string; savedAt: string }[]
  setSavedJobs: React.Dispatch<
    React.SetStateAction<{ jobReferenceClean: string; savedAt: string }[]>
  >
  fetchSimpleSavedJobs: LazyQueryExecFunction<any, OperationVariables>
}>({
  fetchSimpleSavedJobs: () => null,
  savedJobs: [],
  setSavedJobs: () => null,
})
